import callApi from 'helpers/callApi';

export const getScheduleList = (query = {}) => callApi({ url: '/schedules', query });
export const getAllSchedules = (query = {}) => callApi({ url: '/schedules', query: { ...query, limit: 1000, page: 1 } });
export const getSchedule = (scheduleId) => callApi({ url: `/schedules/${scheduleId}` });

export const editSingleSchedule = (classId, scheduleId, data) => callApi({ url: `/classes/${classId}/schedules/${scheduleId}`, body: data, method: 'put' });

// export const addMultipleSchedule = (classId, data) => addMultipleScheduleLoader.post(`/classes/${classId}/multiple/schedules`, { data });
export const editMultipleSchedule = (classId, scheduleId, data) => callApi({ url: `/classes/${classId}/multiple/schedules/${scheduleId}`, body: data, method: 'put' });
export const editFlexibleSchedule = (classId, scheduleId, data) => callApi({ url: `/classes/${classId}/flexible/schedules/${scheduleId}`, body: data, method: 'put' });

export const getClassScheduleOrders = (classId, scheduleId, params = {}) => callApi({ url: `/classes/${classId}/schedules/${scheduleId}/orders`, query: { ...params, limit: 10000 } });
export const getScheduleRevenue = (id) => callApi({ url: `/schedules/${id}/revenues` });
export const deleteSchedule = (scheduleId) => callApi({ url: `/schedules/${scheduleId}`, method: 'delete' });

export const getClassSchedules = (classId, params) => callApi({ url: `/classes/${classId}/schedules`, query: params });

// export const getLatestSchedule = (classId) => getLatestScheduleLoader.get(`/classes/${classId}/latest`);

// // force to get all orders
// export const addSingleSchedule = (classId, data) => addSingleScheduleLoader.post(`/classes/${classId}/schedules`, { data });

// export const addFlexibleSchedule = (classId, data) => addFlexibleScheduleLoader.post(`/classes/${classId}/flexible/schedules`, { data });

// export const getOfferingScheduleList = (classId, params) => getOfferingScheduleListLoader.get(`/classes/${classId}/offering-schedules`, { params });
// export const acceptSchedule = (classId, offeringId, datetime) => answerScheduleLoader.post(`/offering-schedules/${offeringId}/accept`, { data: { datetime } });
// export const rejectSchedule = (classId, offeringId) => answerScheduleLoader.post(`/offering-schedules/${offeringId}/reject`, {});

// export const clearOrderList = () => ({ type: ACTION_TYPES.clearOrderList });
// export const addToWaitingList = (scheduleId) => addToWaitingListLoader.post(`/schedules/${scheduleId}/waiting-list`);
// export const removeFromWaitingList = (scheduleId) => removeFromWaitingListLoader.del(`/schedules/${scheduleId}/waiting-list`);
// export const clearSchedule = () => ({ type: ACTION_TYPES.clearSchedule });

// export const saveOfferingSchedule = (offeringSchedule) => ({
//   type: ACTION_TYPES.saveOfferingSchedule,
//   offeringSchedule,
// });
// export const clearOfferingSchedule = () => ({
//   type: ACTION_TYPES.clearOfferingSchedule,
// });
// export const showScheduleList = (showSchedule) => ({
//   type: ACTION_TYPES.showScheduleList,
//   showSchedule,
// });
